import { Component, Input, OnInit } from "@angular/core";
import { PharmaDataService } from "../pharma-data.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-drug-sales-analysis-grid-section",
  templateUrl: "./drug-sales-analysis-grid-section.component.html",
  styleUrls: ["./drug-sales-analysis-grid-section.component.scss"],
})
export class DrugSalesAnalysisGridSectionComponent implements OnInit {
  @Input() dataSettings;
  @Input() drugResearchParameters: any[] = [];
  isDSMParameterAPIInvoke: boolean = false;
  serviceFunction: Function;
  ticker: string = "";
  currentDapObj: any;
  gridCounts = {
    salesGrid: -1,
    geoBreakoutGrid: -1,
    indicationBreakoutGrid: -1,
    relatedMetricsGrid: -1,
  };
  cTag: number = 0;
  showResearchPopup: boolean = false;
  constructor(
    private dataService: PharmaDataService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.serviceFunction = this.dataService.getSalesGrowthData;
    this.route.params.subscribe((param) => {
      if (param.cTagId) {
        this.cTag = Number(param.cTagId);
      }
    });
    this.dataService.pharmaDSMAccessCheck.subscribe(() => {
      this.getDrugReasearchParameters();
    });
  }

  ngOnDestroy() {
    this.dataService.pharmaDSMAccessCheck.unsubscribe();
  }

  onDataSourceChanged(rowCount, gridName) {
    this.gridCounts[gridName] = rowCount;
    this.getDrugReasearchParameters();
  }

  getDrugReasearchParameters() {
    if (
      this.gridCounts.salesGrid !== -1 &&
      this.gridCounts.geoBreakoutGrid !== -1 &&
      this.gridCounts.indicationBreakoutGrid !== -1 &&
      this.gridCounts.relatedMetricsGrid !== -1
    ) {
      if (
        this.drugResearchParameters.length === 0 &&
        !this.isDSMParameterAPIInvoke &&
        this.dataService.pharmaAccess.hasDSMAccess
      ) {
        this.isDSMParameterAPIInvoke = true;
        const payload = { drugid: this.cTag };
        this.dataService
          .getPharmaDSMDrugParameters(payload)
          .subscribe((resp: any) => {
            this.drugResearchParameters = resp["data"];
          });
      }
    }
  }

  onResearchIconClick(data) {
    this.currentDapObj = {
      parameterid: data.parameterid,
      drugid: data.drugid,
      brokers: data.brokers,
    };
    this.showResearchPopup = true;
  }
  hideResearchInsightPopup() {
    this.showResearchPopup = false;
  }

  showResearchParameterOnGrid(dataSource) {
    if (dataSource.length > 0) {
      const reserchParameterList = this.drugResearchParameters.map(
        (x) => x.parameterid,
      );
      for (const index in dataSource) {
        if (
          "dapparameter" in dataSource[index] &&
          reserchParameterList.includes(
            parseInt(dataSource[index]["dapparameter"]),
          ) &&
          "name" in dataSource[index] &&
          !dataSource[index]["name"].includes("%")
        ) {
          dataSource[index]["isResearchIconShow"] = true;
        }
      }
    }
  }
}
